/**
 * Persists last-known business colors in localStorage so reload / login
 * transitions don't flash fallback colors before Apollo refetches.
 *
 * Strategy A from MFA + theme analysis: trades a 1-frame flash on first
 * login (cache miss) for instant correct colors on every subsequent mount.
 */

const CACHE_KEY = "business_colors_cache"

export interface CachedBusinessColors {
  primaryColor?: string
  secondaryColor?: string
  bannerColor?: string
  separatorColor?: string
  aiColor?: string
  alternativeColor?: string
  illustrationColor?: string
  sideMenuColor?: string
  headerColor?: string
}

export function loadCachedBusinessColors(): CachedBusinessColors | null {
  try {
    const raw = window.localStorage.getItem(CACHE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (parsed && typeof parsed === "object") return parsed as CachedBusinessColors
    return null
  } catch {
    return null
  }
}

export function saveCachedBusinessColors(colors: CachedBusinessColors): void {
  try {
    window.localStorage.setItem(CACHE_KEY, JSON.stringify(colors))
  } catch {
    // localStorage full or disabled — silent no-op
  }
}

export function clearCachedBusinessColors(): void {
  try {
    window.localStorage.removeItem(CACHE_KEY)
  } catch {
    // silent no-op
  }
}
